import { render } from "./DeleteUndeleteAccount.vue?vue&type=template&id=9230c6c2&scoped=true&lang=pug"
import script from "./DeleteUndeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteUndeleteAccount.vue?vue&type=script&lang=js"

import "./DeleteUndeleteAccount.vue?vue&type=style&index=0&id=9230c6c2&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9230c6c2"]])

export default __exports__